import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";

const F = ({ id, label, children }) => (
  <div className="space-y-1.5"><Label htmlFor={id}>{label}</Label>{children}</div>
);

export const GuestForm = ({ quote }) => {
  const [f, setF] = useState({ name: "", email: "", phone: "", note: "", accept_stairs: false, accept_rules: false });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!f.accept_stairs || !f.accept_rules) { setError("Please confirm stair access and the house rules."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/bookings/checkout", { ...f, check_in: quote.check_in, check_out: quote.check_out, guests: quote.guests, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      setError(errMsg(err));
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="mt-6 pt-6 border-t border-border space-y-4" data-testid="guest-form">
      <p className="font-serif text-xl">Guest details</p>
      <F id="g-name" label="Full name"><Input id="g-name" required value={f.name} onChange={set("name")} autoComplete="name" data-testid="guest-name-input" /></F>
      <F id="g-email" label="Email"><Input id="g-email" type="email" required value={f.email} onChange={set("email")} autoComplete="email" data-testid="guest-email-input" /></F>
      <F id="g-phone" label="Phone"><Input id="g-phone" type="tel" required minLength={7} value={f.phone} onChange={set("phone")} autoComplete="tel" data-testid="guest-phone-input" /></F>
      <F id="g-note" label="Arrival note (optional)"><Textarea id="g-note" rows={2} value={f.note} onChange={set("note")} placeholder="Estimated arrival time, reason for visit…" data-testid="guest-note-input" /></F>
      <label className="flex gap-3 items-start text-sm cursor-pointer">
        <Checkbox checked={f.accept_stairs} onCheckedChange={set("accept_stairs")} data-testid="accept-stairs-checkbox" className="mt-0.5" />
        <span>I understand the studio is reached by stairs and every guest is able to climb them.</span>
      </label>
      <label className="flex gap-3 items-start text-sm cursor-pointer">
        <Checkbox checked={f.accept_rules} onCheckedChange={set("accept_rules")} data-testid="accept-rules-checkbox" className="mt-0.5" />
        <span>I agree to the <Link to="/policies/house-rules" target="_blank" className="underline">house rules</Link> (no parties, maximum 2 guests, respect the neighbors).</span>
      </label>
      {error && <p className="text-sm text-destructive" role="alert" data-testid="checkout-error">{error}</p>}
      <button type="submit" disabled={busy || !f.accept_stairs || !f.accept_rules} className="w-full bg-primary text-primary-foreground py-3.5 rounded-full font-semibold hover:bg-[hsl(var(--sage))] transition-colors disabled:opacity-60 flex items-center justify-center gap-2" data-testid="continue-to-payment-button">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} {busy ? "Redirecting to secure checkout…" : "Continue to secure payment"}
      </button>
    </form>
  );
};
